import { Fragment } from 'react';
import { replaceWithNonbreakableSpaces } from '~/utils';

export const errors = {
  NO_SHOP_SEARCH_MADE_ERROR: 'NO_SHOP_SEARCH_MADE_ERROR',
  SHOPS_NOT_FOUND_ERROR: 'SHOPS_NOT_FOUND_ERROR',
  NO_AVAILABLE_PARTNERS_ERROR: 'NO_AVAILABLE_PARTNERS_ERROR',
  NO_ADDRESSES_FOUND_ERROR: 'NO_ADDRESSES_FOUND_ERROR',
  NO_POSTCODE_FOUND_ERROR: 'NO_POSTCODE_FOUND_ERROR',
  ADDRESS_NOT_ENTERED_ERROR: 'ADDRESS_NOT_ENTERED_ERROR',
  ADDRESS_NOT_SELECTED_ERROR: 'ADDRESS_NOT_SELECTED_ERROR',
  SLOT_DATE_NOT_SELECTED_ERROR: 'SLOT_DATE_NOT_SELECTED_ERROR',
  SLOT_TIME_NOT_SELECTED_ERROR: 'SLOT_TIME_NOT_SELECTED_ERROR',
  SOMETHING_WENT_WRONG_ERROR: 'SOMETHING_WENT_WRONG_ERROR',
  STILL_CANT_LOAD_THE_PAGE_ERROR: 'STILL_CANT_LOAD_THE_PAGE_ERROR',
  APPOINTMENT_NO_LONGER_AVAILABLE_ABOUT_YOU_ERROR:
    'APPOINTMENT_NO_LONGER_AVAILABLE_ABOUT_YOU_ERROR',
  APPOINTMENT_CANT_BE_BOOKED_WITHIN_24_HOURS: 'APPOINTMENT_CANT_BE_BOOKED_WITHIN_24_HOURS',
  ABOUT_YOU_FORM_SIZE_AGE_FIELDS_ERROR: 'ABOUT_YOU_FORM_SIZE_AGE_FIELDS_ERROR',
  QUESTION_IN_EDIT_STATE_ERROR: 'QUESTION_IN_EDIT_STATE_ERROR',
  QUESTION_FIELD_ERROR: 'QUESTION_FIELD_ERROR',
  VIEW_CANCELLED_BOOKING: 'GET.booking.already.cancelled',
  EDIT_CANCELLED_BOOKING: 'PUT.booking.already.cancelled',
  RESTORE_OUTDATED_APPOINTMENT_DRAFT: 'appointment.type.is.not.valid.for.service.id',
  APPOINTMENT_TYPE_NOT_SELECTED_ERROR: 'APPOINTMENT_TYPE_NOT_SELECTED_ERROR',
  FITTING_TYPE_NOT_SELECTED_ERROR: 'FITTING_TYPE_NOT_SELECTED_ERROR',
  PIERCING_TYPE_NOT_SELECTED_ERROR: 'PIERCING_TYPE_NOT_SELECTED_ERROR',
  BOOKING_BUG_CLIENT_ERROR: 'client.error',
  FORBIDDEN_ERROR: 'forbidden.error',
  POSTCODE_OUT_OF_AREA_ERROR: 'POSTCODE_OUT_OF_AREA_ERROR',
  TOKEN_INCONSISTENT_DATA_ERROR: 'TOKEN_INCONSISTENT_DATA_ERROR',
  EMPTY_TOKEN_DATA_ERROR: 'EMPTY_TOKEN_DATA_ERROR',
  INVALID_TOKEN_ERROR: 'INVALID_TOKEN_ERROR',
  INVALID_TOKEN_ERROR_GO_TO_BEGIN_OF_JOURNEY: 'INVALID_TOKEN_ERROR_GO_TO_BEGIN_OF_JOURNEY',
  NO_AVAILABLE_PARTNERS_GROUPS_ERROR: 'NO_AVAILABLE_PARTNERS_GROUPS_ERROR',
  BEAUTY_TO_BEAUTY_SOCIETY_PARTNERS_NOT_FOUND: 'BEAUTY_TO_BEAUTY_SOCIETY_PARTNERS_NOT_FOUND',
  BOOK_WITHOUT_MAIN_TREATMENT_ERROR: 'BOOK_WITHOUT_MAIN_TREATMENT_ERROR',
  APPOINTMENT_TYPE_NOT_FOUND: 'APPOINTMENT_TYPE_NOT_FOUND',
  NO_SELECTED_PRODUCTS: 'NO_SELECTED_PRODUCTS',
  SLOT_TIME_UNAVAILABLE_ERROR: 'SLOT_TIME_UNAVAILABLE_ERROR',
};

export const success = {
  CANCEL_APPOINTMENT_BOOKING: 'CANCEL_APPOINTMENT_BOOKING',
  SHOP_IS_DISABLED: 'SHOP_IS_DISABLED',
};

export const info = {
  NO_AVAILABLE_TIME_SLOTS: 'NO_AVAILABLE_TIME_SLOTS',
  ADDRESS_NOT_FOUND: 'ADDRESS_NOT_FOUND',
};

const createErrorMessage = (details) => ({
  notificationType: 'error',
  ...details,
});

const createSuccessMessage = (details) => ({
  notificationType: 'success',
  ...details,
});

const createInfoMessage = (details) => ({
  notificationType: 'info',
  ...details,
});

export const messages = {
  errors: {
    [errors.NO_SHOP_SEARCH_MADE_ERROR]: createErrorMessage({
      title: "You haven't searched for any information",
    }),
    [errors.SHOPS_NOT_FOUND_ERROR]: createErrorMessage({
      title: "We can't find any shops",
    }),
    [errors.NO_AVAILABLE_PARTNERS_ERROR]: createErrorMessage({
      description: 'Please choose another shop to book an appointment.',
    }),
    [errors.NO_ADDRESSES_FOUND_ERROR]: createErrorMessage({
      title: "We can't find any addresses",
    }),
    [errors.NO_POSTCODE_FOUND_ERROR]: createErrorMessage({
      title: "We can't find your postcode",
    }),
    [errors.ADDRESS_NOT_ENTERED_ERROR]: createErrorMessage({
      title: "You haven't completed the areas highlighted",
    }),
    [errors.ADDRESS_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose an address to continue',
    }),
    [errors.SLOT_DATE_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose a date to view available time slots',
    }),
    [errors.SLOT_TIME_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose a time slot to continue',
    }),
    [errors.SOMETHING_WENT_WRONG_ERROR]: createErrorMessage({
      title: 'Sorry, something went wrong',
      description: 'Please try loading the page again.',
    }),
    [errors.FORBIDDEN_ERROR]: createErrorMessage({
      title: 'Sorry, something went wrong',
      description: 'Please try again.',
    }),
    [errors.STILL_CANT_LOAD_THE_PAGE_ERROR]: createErrorMessage({
      title: "Sorry, we still can't load the page",
      description: 'Please try again later.',
    }),
    [errors.APPOINTMENT_NO_LONGER_AVAILABLE_ABOUT_YOU_ERROR]: createErrorMessage({
      description: 'Please choose another time for your appointment.',
    }),
    [errors.APPOINTMENT_CANT_BE_BOOKED_WITHIN_24_HOURS]: createErrorMessage({
      title: 'Sorry, we have not been able to book this appointment',
      description: (
        <Fragment>
          You have already booked an appointment with us. Please call us to change or cancel your
          existing appointment on&nbsp;
          <b>0800 021 4361</b>.
        </Fragment>
      ),
    }),
    [errors.ABOUT_YOU_FORM_SIZE_AGE_FIELDS_ERROR]: createErrorMessage({
      title: "You haven't completed the areas highlighted",
    }),
    [errors.QUESTION_IN_EDIT_STATE_ERROR]: createErrorMessage({
      title: 'Please save your changes.',
    }),
    [errors.QUESTION_FIELD_ERROR]: createErrorMessage({
      title: "You haven't completed the areas highlighted",
    }),
    [errors.VIEW_CANCELLED_BOOKING]: createErrorMessage({
      title: 'Appointment has been cancelled',
      description:
        "You've already cancelled this appointment. Please refresh to see your upcoming appointments.",
    }),
    [errors.EDIT_CANCELLED_BOOKING]: createErrorMessage({
      title: "Appointment can't be found",
      description: "You've already removed this appointment. Please book another appointment.",
    }),
    [errors.APPOINTMENT_TYPE_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose number of children to continue',
    }),
    [errors.FITTING_TYPE_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose a type of fit for each child to continue',
    }),
    [errors.PIERCING_TYPE_NOT_SELECTED_ERROR]: createErrorMessage({
      title: 'Please choose a type of piercing service to continue',
    }),
    [errors.POSTCODE_OUT_OF_AREA_ERROR]: createErrorMessage({
      title: 'Sorry, we do not offer Fitted Bedroom appointments in your area',
      description:
        'Unfortunately, due to travel distances from our shops, it is not possible to offer this service in a limited number of postcode areas.',
    }),
    [errors.TOKEN_INCONSISTENT_DATA_ERROR]: createErrorMessage({
      title: 'Sorry, something went wrong',
      description: 'Please try booking your appointment again.',
    }),
    [errors.INVALID_TOKEN_ERROR_GO_TO_BEGIN_OF_JOURNEY]: createErrorMessage({
      title: 'Sorry, something went wrong',
      description: 'Please try booking your appointment again.',
    }),
    [errors.EMPTY_TOKEN_DATA_ERROR]: createErrorMessage({
      title: 'Sorry, something went wrong',
      description: 'Please try again.',
    }),
    [errors.INVALID_TOKEN_ERROR]: createErrorMessage({
      title: 'Sorry, something went wrong',
    }),
    [errors.NO_AVAILABLE_PARTNERS_GROUPS_ERROR]: createErrorMessage({
      title: 'There are no available appointments for this treatment at this shop',
      description: 'Please try another treatment',
    }),
    [errors.BEAUTY_TO_BEAUTY_SOCIETY_PARTNERS_NOT_FOUND]: createErrorMessage({
      title: 'There are no available appointments at this shop',
      description: 'Please try another treatment',
    }),
    [errors.APPOINTMENT_TYPE_NOT_FOUND]: createErrorMessage({
      title: 'There are no available appointments for this treatment at this shop',
      description: 'Please try another treatment',
    }),
    [errors.BOOK_WITHOUT_MAIN_TREATMENT_ERROR]: createErrorMessage({
      title: 'This add-on can only be booked with a main treatment',
    }),
    [errors.NO_SELECTED_PRODUCTS]: createErrorMessage({
      title: 'Please add a product',
    }),
    [errors.SLOT_TIME_UNAVAILABLE_ERROR]: createErrorMessage({
      title: 'Please choose an alternative date to view available time slots',
    }),
  },
  successes: {
    [success.CANCEL_APPOINTMENT_BOOKING]: createSuccessMessage({
      title: 'Your appointment has been successfully cancelled',
    }),
    [success.SHOP_IS_DISABLED]: createSuccessMessage({
      title: "Our treatments aren't available to book at this time",
    }),
  },
  info: {
    [info.NO_AVAILABLE_TIME_SLOTS]: createInfoMessage({
      title:
        'Unfortunately, there are no longer any time slots available for this date. Please choose an alternate date.',
    }),
    [info.ADDRESS_NOT_FOUND]: createInfoMessage({
      title: "Sorry, we couldn't find your address. Please enter it below.",
    }),
  },
};

export const getErrorMessage = (type) =>
  type.includes(':') ? messages.errors[type.split(':')[1]] : messages.errors[type];
export const getSuccessMessage = (type) => messages.successes[type];
export const getInfoMessage = (type) => messages.info[type];

const getShopsNotFoundDescription = (searchTerm = 'searchTerm') =>
  `We can't find any results for '${replaceWithNonbreakableSpaces(
    searchTerm,
  )}'. Please try searching again.`;
const getNoAddressesFoundDescription = (searchTerm = 'searchTerm') =>
  `We can't find any results for '${replaceWithNonbreakableSpaces(
    searchTerm,
  )}'. Please try searching again.`;
const getNoPostcodeFoundDescription = (searchTerm) =>
  `We can't find any results for '${replaceWithNonbreakableSpaces(
    searchTerm,
  )}'. Please use a different address to continue.`;
const getSlotIsNoLongerAvailable = (dateTime) => `${dateTime} is no longer available`;
const getNoAvailablePartners = (shopName) => `There are no available appointments at ${shopName}`;

Object.defineProperty(messages.errors[errors.SHOPS_NOT_FOUND_ERROR], 'createDescription', {
  value(searchTerm) {
    return getShopsNotFoundDescription(searchTerm);
  },
});

Object.defineProperty(messages.errors[errors.NO_ADDRESSES_FOUND_ERROR], 'createDescription', {
  value(searchTerm) {
    return getNoAddressesFoundDescription(searchTerm);
  },
});

Object.defineProperty(messages.errors[errors.NO_POSTCODE_FOUND_ERROR], 'createDescription', {
  value(searchTerm) {
    return getNoPostcodeFoundDescription(searchTerm);
  },
});

Object.defineProperty(
  messages.errors[errors.APPOINTMENT_NO_LONGER_AVAILABLE_ABOUT_YOU_ERROR],
  'createTitle',
  {
    value(dateTime) {
      return getSlotIsNoLongerAvailable(dateTime);
    },
  },
);

Object.defineProperty(messages.errors[errors.NO_AVAILABLE_PARTNERS_ERROR], 'createTitle', {
  value(shopName) {
    return getNoAvailablePartners(shopName);
  },
});
